import authService from "../services/auth.service";
import tipstersService from "../services/tipsters.service";
import usuariosService from "../services/usuarios.service";
import productosService from "../services/productos.service";
import pedidosService from "../services/pedidos.service";
import canalesService from "../services/canales.service";
import campanasService from "../services/campanas.service";
import configuracionService from "../services/configuracion.service";
import panelesService from "../services/paneles.service";
import publicistasService from "../services/publicistas.service";
import impersonacionService from "../services/impersonacion.service";
import analyticsService from "../services/analytics.service";
import estadisticasService from "../services/estadisticas.service";
import ratesService from "../services/rates.service";
import comisionesService from "../services/comisiones.service";
import movimientosService from "../services/movimientos.service";
import tipsterLandingService from "../services/tipsterLanding.service";
import tipsterCampanasService from "../services/tipsterCampanas.service";

const user = JSON.parse(localStorage.getItem("userF"));

export const auth = {
  namespaced: true,
  state: {
    loggedIn: user ? true : false,
    me: null,
    permisos_finales: [],
    meLoading: false,
  },

  actions: {
    async cargarMeYPermisos({ commit }) {
      commit("setMeLoading", true);
      try {
        const me = await authService.me();
        commit("setMe", me);

        const attrs = me?.data?.attributes || {};

        const rolEfectivo = Number(attrs.rol_efectivo ?? attrs.rol_id ?? 0);

        if (Array.isArray(attrs.permisos_finales)) {
          commit("setPermisosFinales", attrs.permisos_finales);
          localStorage.setItem("permisos_finales", JSON.stringify(attrs.permisos_finales));
        } else {
          console.warn("[auth] /me no devolvió permisos_finales — el servidor debe incluirlos siempre");
          commit("setPermisosFinales", []);
        }

        localStorage.setItem("usuarioRolId", String(rolEfectivo));
      } finally {
        commit("setMeLoading", false);
      }
    },

    // AUTH
    async login({ commit, dispatch }, userData) {
      await authService.login(userData);
      commit("logMeIn");
      await dispatch("cargarMeYPermisos");
    },

    async logout({ commit }) {
      try {
        await authService.logout();
      } finally {
        localStorage.removeItem("usuarioRolId");
        localStorage.removeItem("permisos_finales");
        commit("logMeOut");
        commit("profile/RESET_PROFILE", null, { root: true });
      }
    },

    async register(context, userData) {
      return await authService.register(userData);
    },

    async claveOlvidada(context, userData) {
      return await authService.claveOlvidada(userData);
    },

    async codigoRecuperado(context, pedido) {
      return await authService.codigoRecuperado(pedido);
    },

    async recordarCodigo(context, pedido) {
      return await authService.recordarCodigo(pedido);
    },

    async validaCodigo({ commit, dispatch }, userData) {
      const resp = await authService.validaCodigo(userData);
      if (resp['res'] == 'OK') {
        commit("logMeIn");
        await dispatch("cargarMeYPermisos");
      }
      return resp;
    },

    async establecerClave(context, userData) {
      return await authService.establecerClave(userData);
    },

    async registroEmailSuscripcion(context, data) {
      return await authService.registroEmailSuscripcion(data);
    },

    async registroRapido({ commit, dispatch }, data) {
      const resp = await authService.registroRapido(data);
      if (resp?.res === 'OK') {
        commit('logMeIn');
        commit('setEmailLogueado', data.email || '', { root: true });
        try {
          await dispatch('cargarMeYPermisos');
        } catch (_) {
          // continuar aunque /me falle
        }
      }
      return resp;
    },

    async activarCuentaEmail(context, token) {
      return await authService.activarCuentaEmail(token);
    },

    async validaTelefonoUsuario(context, telefono) {
      return await authService.validaTelefonoUsuario(telefono);
    },

    // IMPERSONACIÓN
    async setRolTemporal({ dispatch }, payload) {
      const resp = await impersonacionService.setRolTemporal(payload);
      await dispatch("cargarMeYPermisos");
      return resp;
    },

    async clearRolTemporal({ dispatch }) {
      const resp = await impersonacionService.clearRolTemporal();
      await dispatch("cargarMeYPermisos");
      return resp;
    },

    // TIPSTERS
    async tipsters(context, tipster) {
      return await tipstersService.tipsters(tipster);
    },

    async exportarTipsters() {
      return await tipstersService.exportarTipsters();
    },

    async listaTipsters() {
      return await tipstersService.listaTipsters();
    },

    async misTipsters() {
      return await tipstersService.misTipsters();
    },

    async tablaTipsters() {
      return await tipstersService.tablaTipsters();
    },

    async guardaTipster(context, tipster) {
      return await tipstersService.guardaTipster(tipster);
    },

    async detalleTipster(context, data) {
      return await tipstersService.detalleTipster(data);
    },

    async borraTipster(context, tipster) {
      return await tipstersService.borraTipster(tipster);
    },

    async informeComisiones(context, data) {
      return await comisionesService.informe(data);
    },

    async exportarComisiones(context, data) {
      return await comisionesService.exportar(data);
    },

    async detalleComisiones(context, data) {
      return await comisionesService.detalle(data);
    },

    async listarMovimientos(context, params) {
      return await movimientosService.listar(params);
    },

    async validarMovilTipster(context, tipster) {
      return await tipstersService.validarMovilTipster(tipster);
    },

    async codigoMovilTipster(context, tipster) {
      return await tipstersService.codigoMovilTipster(tipster);
    },

    async validaCodigoTipster(context, tipster) {
      return await tipstersService.validaCodigoTipster(tipster);
    },

    // USUARIOS
    async usuarios(context, usuario) {
      return await usuariosService.usuarios(usuario);
    },

    async guardaUsuario(context, usuario) {
      return await usuariosService.guardaUsuario(usuario);
    },

    async borraUsuario(context, usuario) {
      return await usuariosService.borraUsuario(usuario);
    },

    async generarClaveUsuario(context, usuario) {
      return await usuariosService.generarClaveUsuario(usuario);
    },

    async listaRoles() {
      return await usuariosService.listaRoles();
    },

    async listaPermisos() {
      return await usuariosService.listaPermisos();
    },

    async exportarUsuarios() {
      return await usuariosService.exportarUsuarios();
    },

    // PRODUCTOS
    async productos(context, producto) {
      return await productosService.productos(producto);
    },

    async exportarProductos() {
      return await productosService.exportarProductos();
    },

    async listaProductosSimple(context, tipsterId) {
      return await productosService.listaSimple(tipsterId);
    },

    async guardaProducto(context, producto) {
      return await productosService.guardaProducto(producto);
    },

    async borraProducto(context, producto) {
      return await productosService.borraProducto(producto);
    },

    async obtenerRebajaProducto(context, data) {
      return await productosService.obtenerRebajaProducto(data);
    },

    async consultaProducto(context, uuid) {
      return await productosService.consultaProducto(uuid);
    },

    async validarDescuento(context, datos) {
      try {
        const resp = await productosService.validarDescuento(datos);
        return resp.data;
      } catch (e) {
        return { res: "NOK", mensaje: "Error de conexión" };
      }
    },

    // PEDIDOS
    async pedidos(context, pedido) {
      return await pedidosService.pedidos(pedido);
    },

    async exportarPedidos() {
      return await pedidosService.exportarPedidos();
    },

    async detallePedido(context, pedido) {
      return await pedidosService.detallePedido(pedido);
    },

    async generarPedido(context, pedido) {
      return await pedidosService.generarPedido(pedido);
    },

    async estadoPedidoPago(context, payload) {
      return await pedidosService.estadoPedidoPago(payload);
    },

    async confirmarPagado(context, pedido) {
      return await pedidosService.confirmarPagado(pedido);
    },

    async confirmarTrial(context, payload) {
      return await pedidosService.confirmarTrial(payload);
    },

    tipsterProductoCompradores(context, payload) {
      return pedidosService.tipsterProductoCompradores(payload);
    },

    // CANALES
    async canales(context, canal) {
      return await canalesService.canales(canal);
    },

    async productosDelCanal(context, canal_id) {
      return await canalesService.productosDelCanal(canal_id);
    },

    async exportarCanales() {
      return await canalesService.exportarCanales();
    },

    async guardaCanal(context, canal) {
      return await canalesService.guardaCanal(canal);
    },

    async borraCanal(context, canal) {
      return await canalesService.borraCanal(canal);
    },

    async listaCanales(context, tipster) {
      return await canalesService.listaCanales(tipster);
    },

    async verificarCanal(context, payload) {
      return await canalesService.verificarCanal(payload);
    },

    async tablaCanales(context, tipster) {
      return await canalesService.tablaCanales(tipster);
    },

    // CAMPAÑAS
    async campanas(context, campana) {
      return await campanasService.campanas(campana);
    },

    async exportarCampanas() {
      return await campanasService.exportarCampanas();
    },

    async campanaDetalle(context, { campana_id, tipo }) {
      return await campanasService.campanaDetalle(campana_id, tipo);
    },

    async campanaActualizarNicks(context, campana_id) {
      return await campanasService.campanaActualizarNicks(campana_id);
    },

    async guardaCampana(context, campana) {
      return await campanasService.guardaCampana(campana);
    },

    async borraCampana(context, campana) {
      return await campanasService.borraCampana(campana);
    },

    async grupoTelegram(context, canal) {
      return await campanasService.grupoTelegram(canal);
    },

    async exportarGrupoTelegram(context, idCanal) {
      return await canalesService.exportarGrupoTelegram(idCanal);
    },

    async campanasTipsters() {
      return await campanasService.campanasTipsters();
    },

    async campanasCanales(context, payload) {
      return await campanasService.campanasCanales(payload);
    },

    // TIPSTER CAMPAÑAS
    async tipsterCampanasListar(context, tipsterId = null) {
      return await tipsterCampanasService.listar(tipsterId);
    },
    async tipsterCampanasCanalesFree(context, tipsterId = null) {
      return await tipsterCampanasService.canalesFree(tipsterId);
    },
    async tipsterCampanasCrearEnlace(context, payload) {
      return await tipsterCampanasService.crearEnlace(payload);
    },
    async tipsterCampanasBorrarEnlace(context, { id, tipsterId = null }) {
      return await tipsterCampanasService.borrarEnlace(id, tipsterId);
    },

    // TIPSTER LANDING
    async tipsterLandingObtener(context, payload = {}) {
      return await tipsterLandingService.obtener(payload);
    },
    async tipsterLandingCrear(context, payload) {
      return await tipsterLandingService.crear(payload);
    },
    async tipsterLandingGuardar(context, payload) {
      return await tipsterLandingService.guardar(payload);
    },
    async tipsterLandingBorrar(context, id) {
      return await tipsterLandingService.borrar(id);
    },
    async tipsterLandingUploadImagen(context, { tipsterId, file }) {
      return await tipsterLandingService.uploadImagen(tipsterId, file);
    },

    // CONFIGURACIÓN
    async configuracion(context, { silent403, ...configuracion } = {}) {
      return await configuracionService.configuracion(configuracion, !!silent403);
    },

    async guardaConfiguracion(context, configuracion) {
      return await configuracionService.guardaConfiguracion(configuracion);
    },

    async lanzaValidacionMovil(context, configuracion) {
      return await configuracionService.lanzaValidacionMovil(configuracion);
    },

    async resetSistema() {
      return await configuracionService.resetSistema();
    },

    async backupBd() {
      return await configuracionService.backupBd();
    },

    async syncProdEstado() {
      return await configuracionService.syncProdEstado();
    },
    async syncProdCredenciales(context, datos) {
      return await configuracionService.syncProdCredenciales(datos);
    },
    async syncProdImportar(context, tablas) {
      return await configuracionService.syncProdImportar(tablas);
    },
    async syncProdLimpiar() {
      return await configuracionService.syncProdLimpiar();
    },
    async logsProxy(context, payload) {
      return await configuracionService.logsProxy(payload.url_prod, payload.token_prod, payload.archivo || null);
    },
    async logsGuardar(context, { archivo, contenido }) {
      return await configuracionService.logsGuardar(archivo, contenido);
    },

    // PANELES
    async tipsterPanel(context, payload) {
      return await panelesService.tipsterPanel(payload);
    },

    async tipsterPanelAdmin(context, { tipsterId, payload }) {
      return await panelesService.tipsterPanelAdmin(tipsterId, payload);
    },

    async suscripcionesLista(context, params = {}) {
      return await panelesService.suscripcionesLista(params);
    },

    async suscripcionesListaAdmin(context, { tipsterId, params }) {
      return await panelesService.suscripcionesListaAdmin(tipsterId, params ?? {});
    },

    async clientePanel(context, payload) {
      return await panelesService.clientePanel(payload);
    },

    async clientePanelAdmin(context, { userId, payload }) {
      return await panelesService.clientePanelAdmin(userId, payload);
    },

    async listaClientesAdmin() {
      return await panelesService.listaClientesAdmin();
    },

    async publicistaPanel(context, payload) {
      return await panelesService.publicistaPanel(payload);
    },

    // PUBLICISTAS
    async publicistas(context, payload) {
      return await publicistasService.publicistas(payload);
    },

    async publicistaTipsters(context, payload) {
      return await publicistasService.publicistaTipsters(payload);
    },

    async guardaPublicistaTipsters(context, payload) {
      return await publicistasService.guardaPublicistaTipsters(payload);
    },

    // ESTADÍSTICAS
    async estadisticas() {
      return await estadisticasService.estadisticas();
    },

    // ANALYTICS
    async analyticsParticipantes(context, payload) {
      return await analyticsService.analyticsParticipantes(payload);
    },

    async analyticsParticipantesExport(context, payload) {
      return await analyticsService.analyticsParticipantesExport(payload);
    },

    async analyticsParticipantesDetalle(context, payload) {
      return await analyticsService.analyticsParticipantesDetalle(payload);
    },

    async analyticsActualizarNicks(context, payload) {
      return await analyticsService.analyticsActualizarNicks(payload);
    },

    async analyticsParticipantesPorUsuario(context, payload) {
      return await analyticsService.analyticsParticipantesPorUsuario(payload);
    },

    async analyticsParticipantesPorUsuarioExport(context, payload) {
      return await analyticsService.analyticsParticipantesPorUsuarioExport(payload);
    },

    async analyticsVentas(context, payload) {
      return await analyticsService.analyticsVentas(payload);
    },

    async analyticsVentasDetalle(context, payload) {
      return await analyticsService.analyticsVentasDetalle(payload);
    },

    async analyticsVentasDetalleProducto(context, payload) {
      return await analyticsService.analyticsVentasDetalleProducto(payload);
    },

    // RATES (público)
    async getRates(context, to) {
      return await ratesService.getRates(to);
    },
  },

  mutations: {
    setMeLoading(state, v) {
      state.meLoading = !!v;
    },

    logMeIn(state) {
      state.loggedIn = true;
    },

    logMeOut(state) {
      state.loggedIn = false;
      state.me = null;
      state.permisos_finales = [];
      state.meLoading = false;
    },

    setMe(state, payload) {
      state.me = payload;
    },

    setPermisosFinales(state, permisos) {
      state.permisos_finales = Array.isArray(permisos) ? permisos : [];
    },
  },

  getters: {
    loggedIn(state) {
      return state.loggedIn;
    },
    rolEfectivo(state) {
      const attrs = state.me?.data?.attributes || {};
      return Number(attrs.rol_efectivo ?? attrs.rol_id ?? 0);
    },
    permisos(state) {
      return state.permisos_finales;
    },
  },
};
